import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/LK_Inventorys/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/LK_Inventorys/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/LK_Inventorys/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/LK_Inventorys/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/LK_Inventorys/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/LK_Inventorys/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/LK_Inventorys/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
